import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ja from './locales/ja.json';
import en from './locales/en.json';

const STORAGE_KEY = 'ohat_lang';

export const getStoredLang = (): 'ja' | 'en' => {
  const v = localStorage.getItem(STORAGE_KEY);
  return v === 'en' ? 'en' : 'ja';
};

export const setLang = (lng: 'ja' | 'en') => {
  localStorage.setItem(STORAGE_KEY, lng);
  i18n.changeLanguage(lng);
};

i18n.use(initReactI18next).init({
  resources: {
    ja: { translation: ja },
    en: { translation: en },
  },
  lng: getStoredLang(),
  fallbackLng: 'ja',
  interpolation: { escapeValue: false },
});

export default i18n;
